
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Blog() {
  const blogPosts = [
    {
      id: 1,
      title: "How You Can Volunteer and Make a Difference",
      excerpt: "Discover the many ways you can volunteer with us and help save cats in need. From fostering to fundraising, every contribution matters.",
      category: "VOLUNTEER",
      categoryColor: "text-orange-600",
      date: "March 15, 2024",
      readTime: "5 min read",
      image: "https://public.readdy.ai/ai/img_res/96f75f6bb9b32b47e1e5fc51e1b10686.jpg",
      featured: true
    },
    {
      id: 2,
      title: "Luna Finds Her Forever Home",
      excerpt: "Read about Luna's incredible journey from a scared stray to a beloved family member, and how love transformed her life.",
      category: "SUCCESS STORY",
      categoryColor: "text-blue-600",
      date: "March 10, 2024",
      readTime: "3 min read",
      image: "https://readdy.ai/api/search-image?query=Heartwarming%20cat%20adoption%20success%20story%20showing%20a%20happy%20family%20with%20their%20newly%20adopted%20rescue%20cat%20in%20a%20cozy%20home%20living%20room%2C%20smiling%20people%20holding%20a%20beautiful%20cat%2C%20warm%20natural%20lighting%2C%20emotional%20joyful%20moment%2C%20professional%20photography%2C%20no%20cages%20anywhere%20in%20scene&width=600&height=400&seq=success-story-nocages&orientation=landscape"
    },
    {
      id: 3,
      title: "Essential Cat Health Care Tips",
      excerpt: "Learn important health care tips to keep your feline friend happy and healthy throughout their life.",
      category: "HEALTH TIPS",
      categoryColor: "text-green-600",
      date: "March 5, 2024",
      readTime: "7 min read",
      image: "https://readdy.ai/api/search-image?query=Professional%20veterinarian%20examining%20a%20healthy%20cat%20in%20a%20modern%20open%20clinic%20setting%2C%20medical%20equipment%20on%20counters%2C%20caring%20hands%20checking%20cat%20health%20on%20examination%20table%20in%20bright%20open%20space%2C%20clean%20white%20environment%2C%20professional%20healthcare%20photography%2C%20absolutely%20no%20cages%20visible%20anywhere&width=600&height=400&seq=health-tips-nocages&orientation=landscape"
    },
    {
      id: 4,
      title: "The Importance of Spaying and Neutering",
      excerpt: "Understanding why spaying and neutering is crucial for controlling pet population and improving cat health.",
      category: "EDUCATION",
      categoryColor: "text-purple-600",
      date: "February 28, 2024",
      readTime: "4 min read",
      image: "https://readdy.ai/api/search-image?query=Professional%20veterinary%20team%20preparing%20for%20spay%20neuter%20surgery%20in%20a%20modern%20open%20clinic%2C%20surgical%20instruments%20on%20tables%2C%20veterinarians%20in%20scrubs%20preparing%20equipment%20in%20bright%20clean%20surgical%20suite%2C%20professional%20medical%20photography%2C%20no%20cages%20or%20kennels%20visible%20anywhere&width=600&height=400&seq=spay-neuter-nocages&orientation=landscape"
    },
    {
      id: 5,
      title: "Creating a Cat-Friendly Home Environment",
      excerpt: "Tips and tricks for making your home the perfect sanctuary for your new feline family member.",
      category: "ADOPTION TIPS",
      categoryColor: "text-indigo-600",
      date: "February 20, 2024",
      readTime: "6 min read",
      image: "https://readdy.ai/api/search-image?query=Beautiful%20cat-friendly%20home%20interior%20with%20comfortable%20furniture%2C%20cat%20trees%2C%20toys%20scattered%20around%2C%20cozy%20living%20spaces%20designed%20for%20cats%2C%20warm%20natural%20lighting%2C%20modern%20home%20decor%2C%20cats%20relaxing%20freely%20in%20open%20spaces%2C%20no%20cages%20or%20confined%20areas%20anywhere&width=600&height=400&seq=cat-home-nocages&orientation=landscape"
    },
    {
      id: 6,
      title: "Rescue Stories: From Street to Sweet",
      excerpt: "Heartwarming stories of cats who overcame difficult circumstances to find loving homes.",
      category: "RESCUE STORIES",
      categoryColor: "text-pink-600",
      date: "February 15, 2024",
      readTime: "8 min read",
      image: "https://readdy.ai/api/search-image?query=Before%20and%20after%20transformation%20of%20rescued%20cats%20showing%20healthy%20happy%20cats%20in%20comfortable%20open%20shelter%20environment%2C%20cats%20playing%20and%20relaxing%20in%20bright%20open%20spaces%2C%20professional%20photography%20showing%20rescue%20success%2C%20warm%20lighting%2C%20no%20cages%20or%20confined%20spaces%20visible%20anywhere&width=600&height=400&seq=rescue-transformation-nocages&orientation=landscape"
    }
  ];

  const featuredPost = blogPosts.find(post => post.featured);
  const regularPosts = blogPosts.filter(post => !post.featured);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">Our Blog</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Stay updated with rescue stories, cat care tips, volunteer opportunities, and everything happening at El Dorado Cat Rescue.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Post */}
      {featuredPost && (
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                <div className="relative">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20happy%20volunteers%20working%20together%20at%20an%20open%20animal%20shelter%20with%20no%20cages%20visible%2C%20people%20of%20different%20ages%20feeding%20cats%20in%20open%20comfortable%20spaces%2C%20cleaning%20open%20areas%2C%20playing%20with%20cats%20roaming%20freely%2C%20volunteers%20wearing%20matching%20t-shirts%2C%20warm%20community%20atmosphere%2C%20professional%20photography%20style&width=600&height=400&seq=volunteer-blog-nocages&orientation=landscape"
                    alt="Volunteers helping cats at the shelter"
                    className="w-full h-64 object-cover object-top"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-orange-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      FEATURED
                    </span>
                  </div>
                </div>
                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <div className={`text-sm font-semibold mb-3 ${featuredPost.categoryColor}`}>
                    {featuredPost.category}
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    {featuredPost.title}
                  </h2>
                  <p className="text-gray-600 mb-6 text-lg">
                    {featuredPost.excerpt}
                  </p>
                  <div className="flex items-center text-sm text-gray-500 mb-6">
                    <span>{featuredPost.date}</span>
                    <span className="mx-2">•</span>
                    <span>{featuredPost.readTime}</span>
                  </div>
                  <Button className="w-fit">
                    Read Full Article
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Blog Posts Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12">Recent Posts</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {regularPosts.map((post) => (
              <article key={post.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                <img 
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className={`text-sm font-semibold mb-2 ${post.categoryColor}`}>
                    {post.category}
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-gray-900">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-sm text-gray-500">
                      <span>{post.date}</span>
                      <span className="mx-2">•</span>
                      <span>{post.readTime}</span>
                    </div>
                    <button className="text-orange-600 hover:text-orange-700 font-semibold text-sm">
                      Read More →
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Volunteer CTA Section */}
      <section className="py-20 bg-orange-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Make a Difference?
          </h2>
          <p className="text-xl text-orange-100 mb-8">
            Join our amazing team of volunteers and help us save more cats in need. 
            Every hour you contribute makes a real impact in a cat's life.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-white text-orange-600 hover:bg-gray-100 px-8 py-4">
                <i className="ri-hand-heart-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Volunteer Today
              </Button>
            </Link>
            <Link to="/donate">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-orange-600 px-8 py-4">
                <i className="ri-gift-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Donate Instead
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Stay Updated
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Subscribe to our newsletter to get the latest rescue stories, adoption updates, and volunteer opportunities.
          </p>
          <div className="max-w-md mx-auto">
            <div className="flex gap-4">
              <input 
                type="email" 
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              />
              <Button className="px-6 py-3 whitespace-nowrap">
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
